import $ from 'jquery';

$.fn.callbackForm = function(options) {
  function init($form) {
    var $container = $('.js_callback_form_container', $form);
    var $submit = $('.js_callback_submit', $form);
    var $phone = $('.js_callback_form_phone', $form);
    var $success = $('.js_callback_success', $form);
    var isInProgress = false;
    
    $phone.mask("+7 (999) 999 99 99");

    $form.formValidation({
      success: function(e, $form) {
        e.preventDefault();

        if (isInProgress) return;
        isInProgress = true;
        
        $submit.addClass('m_loading');
        
        var values = $form.serialize().split('&');
        $.post('/wp-admin/admin-ajax.php', {
          action: 'send_callback',
          name: decodeURIComponent(values[0].split('=')[1]),
          phone: decodeURIComponent(values[1].split('=')[1])
        }, function(response) {
          onSuccess(response);
        }, 'json');  
      }
    });

    function onSuccess(response) {
      isInProgress = false;
      
      if (response.status == 'ok') {
        $container.slideUp(200)
        $success.slideDown(200)
      }
    }
  }

  
  this.each(function(index, el) {
    init($(this));
  });
}

export default function() {
  $('.js_callback_form').callbackForm();
}